<template>
  <div class="month-status-box">
    <div class="month-status" v-for="i in 12">
      <div class="name">
        {{ i }}月
      </div>
      <div class="value"
           :class="standardData[i] ? $util.getRiskLevelBgColor(standardData[i].level) : 'default-bg-color'">
        {{ standardData[i] ? standardData[i].value : null }}
      </div>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import {showMessage} from "../../../utils/notice";

export default {
  props: {
    coreRisk: String,
    system: String,
    year: Number,
  },
  data() {
    return {
      monthData: [],
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    buildData() {
      if (this.coreRisk) {
        getRequest("/risk/core/month",
          {coreRisk: this.coreRisk, year: this.year})
          .then(res => {
            this.monthData = res.data
          })
      } else if (this.system) {
        getRequest("/process/key/month",
          {system: this.system, year: this.year})
          .then(res => {
            this.monthData = res.data
          })
      } else {
        showMessage("error", "开发时错误")
      }
    }
  },
  watch: {
    coreRisk() {
      this.buildData();
    },
    system() {
      this.buildData();
    },
    year() {
      this.buildData();
    },
  },
  computed: {
    //转为以"月"为键的map
    standardData() {
      let data = {};
      this.monthData.forEach(function (item) {
        data[item.month] = {value: item.score, level: item.color}
      })
      return data;
    }
  }
}
</script>

<style scoped lang="less">

.month-status-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.month-status {
  width: 8.2%;
  text-align: center;
  font-size: 12px;

  .name {
    margin-bottom: 5px;
  }

  .value {
    display: flex;
    align-items: center;
    height: 22px;
    justify-content: center;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/risk/CoreRiskMonth.vue